export default __webpack_public_path__ + "static/media/ep1collage2.eecf7238.jpg";